"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafeHtmlParse = exports.HtmlWidget = void 0;
const react_1 = __importDefault(require("react"));
const dangerously_set_html_content_1 = __importDefault(require("dangerously-set-html-content"));
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const styles_1 = require("./styles");
const HtmlWidget = (props) => {
    const { html = '', isDangerousHtml = false } = props, rest = __rest(props, ["html", "isDangerousHtml"]);
    if (!html) {
        return null;
    }
    if (!isDangerousHtml) {
        monera_app_core_1.LOGGER.info('If you do not see HTML content rendered, please set the isDangerousHTML prop to true such that you acknowledge the risk of rendering non-sanitised HTMl content');
    }
    return isDangerousHtml ? (react_1.default.createElement(styles_1.StyledHtmlWidgetContainer, Object.assign({ "data-cy": 'html-widget-container' }, rest),
        react_1.default.createElement(dangerously_set_html_content_1.default, { html: html }))) : null;
};
exports.HtmlWidget = HtmlWidget;
const SafeHtmlParse = (html) => {
    if (!html) {
        return null;
    }
    const options = {
        replace(domNode) {
            if (domNode && (domNode.type === 'script' || domNode.name === 'form')) {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
            return;
        }
    };
    return (0, html_react_parser_1.default)(html, options);
};
exports.SafeHtmlParse = SafeHtmlParse;
